export const CONFIGURATION = {
    getSystemConfigs: 'system-configs',
    getListGoogleAnalytics: '/google-analytics/getlist',
    inseGoogleAnalytic: '/google-analytics/insert',
    updateGoogleAnalytic: '/google-analytics/update',
    deleteGoogleAnalytic: '/google-analytics/{id}',
    getValueConfigs: '/configurations/config-value?SystemConfigKeys='
};